import React, { useState } from "react";

export const VehiclesContext = React.createContext();

const VehiclesProvider = (props) => {
  const [contextListVehicles, setContextListVehicles] = useState([]);
  const [contextVehicleRefresh, setContextVehicleRefresh] = useState({
    IdVehicle: null,
    counter: 0,
  });
  const [
    contextDirectPurchaseRefresh,
    setContextDirectPurchaseRefresh,
  ] = useState({
    IdVehicle: null,
    counter: 0,
  });
  const [contextBatchRefresh, setContextBatchRefresh] = useState({
    Vehicles: null,
    counter: 0,
    status: false,
  });
  const [selectedVehicle, setSelectedVehicle] = useState(null);
  const [favouriteRefresh, setFavouriteRefresh] = useState({
    IdVehicle: null,
    counter: 0,
    isFavorite: false,
  });

  const [showSimulationsRVO, setShowSimulationsRVO] = useState(false);

  return (
    <VehiclesContext.Provider
      value={{
        selectedVehicle,
        contextListVehicles,
        contextVehicleRefresh,
        contextBatchRefresh,
        contextDirectPurchaseRefresh,
        favouriteRefresh,
        showSimulationsRVO,
        setSelectedVehicle,
        setContextListVehicles,
        setContextVehicleRefresh,
        setContextDirectPurchaseRefresh,
        setContextBatchRefresh,
        setFavouriteRefresh,
        setShowSimulationsRVO,
      }}
    >
      {props.children}
    </VehiclesContext.Provider>
  );
};

export default VehiclesProvider;
